"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var React = require("react");
var SvgCenter = function SvgCenter(props) {
  return React.createElement("svg", __assign({
    width: 1792,
    height: 1792,
    viewBox: "0 0 1792 1792"
  }, props), React.createElement("g", {
    id: "aea5b74d-fe51-4fe6-92c6-d0331297e59a",
    "data-name": "\\u30E9\\u30D9\\u30EB"
  }, React.createElement("rect", {
    x: 318.55,
    y: 620.58,
    width: 1152,
    height: 546
  }), React.createElement("rect", {
    x: 172.85,
    y: -2.21,
    width: 1443.13,
    height: 181
  }), React.createElement("rect", {
    x: 172.85,
    y: 309.79,
    width: 1443.13,
    height: 181
  }), React.createElement("rect", {
    x: 172.85,
    y: 1296.79,
    width: 1443.13,
    height: 181
  }), React.createElement("rect", {
    x: 172.85,
    y: 1608.79,
    width: 1443.13,
    height: 181
  })));
};
exports.default = SvgCenter;